//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "constants/actionType";


let initialState = {
    enrolled_debt: "",
    term: "", 
    purchaser_status: "",
    enrolled_services: [], 
    income: "",
    expenses: "",
    last_note_date: "",
    next_appointment_date: "",
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.CLIENT_HEADER_ENROLLED_SERVICES:
            return _.assign({}, state, {
                enrolled_services: action.enrolled_services
            });
        case actionType.CLIENT_HEADER_TERM:
            return _.assign({}, state, {
                term: action.term
            });

        case actionType.CLIENT_HEADER_NEXT_APPOINTMENT_DATE:
            return _.assign({}, state, {
                next_appointment_date: action.next_appointment_date
            });
        case actionType.CLIENT_HEADER_PURCHASE_STATUS:
            return _.assign({}, state, {
                purchaser_status: action.purchaser_status
            }); 
        case actionType.CLIENT_HEADER_EXPENSES:
            return _.assign({}, state, {
                expenses: action.expenses
            });
        case actionType.CLIENT_HEADER_INCOME:
            return _.assign({}, state, {
                income: action.income
            });
        case actionType.CLIENT_HEADER_LAST_NOTE_DATE:
            return _.assign({}, state, {
                last_note_date: action.last_note_date
            });

        case actionType.CLIENT_HEADER_DETAIL_RESET:
            return initialState;
        default:
            return state;
    }
}